import { Colors } from "@constants";
import style from "styled-components/native";

export const Container = style.TouchableOpacity<{
  color?: string;
}>`
  background-color: ${({ color }) => color || Colors.foodiDefault};
  justify-content: center;
  border-radius: 8px;
`;

export const Label = style.Text<{
  textColor?: string;
  hide?: boolean;
  padding?: string | number
}>`
  padding: ${({ padding }) => padding || '15px 54px'};
  color: ${({ textColor }) => textColor || Colors.foodiBlack};
  font-family: manrope-bold;
  font-size: 22px;
  letter-spacing: 0;
  line-height: 30px;
  text-align: center;
  opacity: ${({ hide }) => hide ? 0 : 1};
`;
